import React from "react";

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

const Footer = () =>{

   
    return(
      <>
        <footer id="footer">
    <div className="footer-top">
      <div className="container">
        <div className="row">

          <div className="col-lg-4 col-md-6">
            <div className="footer-info">
              <h3>SpireWeb Technologies</h3>
              <p>
               <strong>Registered Corporate Office :</strong><br></br>  A/P- Plot No 47, Trimurti Colony, <br/>
               Nave Pargaon Tal- Hatkanangle, Dist- Kolhapur 416 113.<br/><br/>
               <strong>Other Office Locations :&nbsp;</strong>
                Pune | Warananagar | Peth Vadgaon  <br></br>
                <strong>Phone: </strong><a href="tel:+918806122020">+91 880 612 2020</a> <br/>
                <strong>Email: </strong><a href="mailto:info@spirewebtechnologies.com">info@spirewebtechnologies.com</a> <br/>
              </p>
              <div class="social-links mt-3">
                {/* <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a> */}
                <a href="https://www.facebook.com/SpireWebTechnologies" target= "_blank" className="facebook"><i className="bx bxl-facebook"></i></a>
                <a href="https://www.instagram.com/spirewebtechnologies/" target= "_blank" className="instagram"><i className="bx bxl-instagram"></i></a>
                <a href="https://www.youtube.com/@spirewebtechnologies" target= "_blank" className="youtube"><i className="bx bxl-youtube"></i></a>
                <a href="#" className="linkedin"><i className="bx bxl-linkedin"></i></a>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-6 footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><i className="bx bx-chevron-right"></i> <a href="#hero">Home</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#about">About us</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#services">Services</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#">Terms of service</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-6 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><i className="bx bx-chevron-right"></i> <a href="#services">Web Design</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#services">Web Development</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#services">Product Management</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#services">Marketing</a></li>
              <li><i className="bx bx-chevron-right"></i> <a href="#services">Graphic Design</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-6 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Connect with us on our social media for latest deals and discounts</p>
            <form action="" method="post"> 
             <input type="email" name="email" />
                <input type="submit" value="Subscribe" /> 
                </form>
            
             

          </div>

        </div>
      </div>
    </div>

    <div className="container">
      <div className="copyright">
        &copy; 2023<strong><span> SpireWeb Technologies</span></strong>. | All Rights Reserved
      </div>
      <div className="credits">
      
            Designed by <a href="https://spirewebtechnologies.com/">SpireWeb Technologies</a>
      </div>
    </div>
  </footer>

<a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

</>
    )
}


export default Footer;